// extracted by mini-css-extract-plugin
module.exports = {"multiSelect":"MultiSelect_multiSelect__23phK","label":"MultiSelect_label__22FKJ","inputValue":"MultiSelect_inputValue__3qGGU"};